import { Preferences } from '@capacitor/preferences';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

const SUPPORTED_LANGUAGES = ['en', 'fr'];

/**
 * Resolve the app language from the first valid source, in order:
 * - stored language preference
 * - browser language (when supported)
 * - configured default language
 */
export const resolveAppLanguage = async (
  translate: TranslateService
): Promise<string> => {
  const { value: languagePref } = await Preferences.get({ key: 'language' });
  if (languagePref) {
    return languagePref;
  }

  const browserLanguage = translate.getBrowserLang();
  if (browserLanguage && SUPPORTED_LANGUAGES.includes(browserLanguage)) {
    return browserLanguage;
  }

  return translate.getDefaultLang();
};

export const initTranslationsFactory =
  (translate: TranslateService) => async (): Promise<void> => {
    const language = await resolveAppLanguage(translate);
    await firstValueFrom(translate.use(language));
  };
